import {Difficulty, Duration, ScoreCategory} from "../types/leaderboard";

export const COMPETITION_ROWS: {
  label: string;
  categories: {key: ScoreCategory; durationLabel: string }[];
}[] = [
  {
    label: Difficulty.HARD,
    categories: [
      {key: ScoreCategory.Competition1minHard, durationLabel: Duration.S1M},
      {key: ScoreCategory.Competition3minHard, durationLabel: Duration.S3M},
      {key: ScoreCategory.Competition5minHard, durationLabel: Duration.S5M},
    ],
  },
  {
    label: Difficulty.MEDIUM,
    categories: [
      {key: ScoreCategory.Competition1minMedium, durationLabel: Duration.S1M},
      {key: ScoreCategory.Competition3minMedium, durationLabel: Duration.S3M},
      {key: ScoreCategory.Competition5minMedium, durationLabel: Duration.S5M},
    ],
  },
  {
    label: Difficulty.EASY,
    categories: [
      {key: ScoreCategory.Competition1minEasy, durationLabel: Duration.S1M},
      {key: ScoreCategory.Competition3minEasy, durationLabel: Duration.S3M},
      {key: ScoreCategory.Competition5minEasy, durationLabel: Duration.S5M},
    ],
  },
];

export const QUESTIONS_CATEGORIES: ScoreCategory[] = [
  ScoreCategory.Questions100Easy,
  ScoreCategory.Questions100Medium,
  ScoreCategory.Questions100Hard,
];
